import { createContext } from 'react';

import { ByIdStructureWithArray, ModelOptions } from '../../../types';
import { CountryCode } from '../types';
import api from '../api';

type CountryCodesContextType<T> = {
    get: (params?: Partial<T>, options?: ModelOptions, updateState?: boolean) => Promise<Array<T>>;
    data: ByIdStructureWithArray<T>;
};

const countryCodesContext = createContext<CountryCodesContextType<CountryCode>>({
    get: api.get,
    data: { ids: [], byId: {}, asArray: [] }
});
export default countryCodesContext;
